import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { getSprintWorkspacePath } from "../api/trustbuds";

export default function TrustBudDashboardPage() {
  const { userId, sprintId } = useParams();

  return (
    <Navigate
      to={getSprintWorkspacePath({
        sprintId,
        userId,
      })}
      replace
    />
  );
}
